import React from "react";
import { S } from "./styles";

/**
 * Free Essentials Check progress bar — the core "shopping funds health"
 * mechanic. Sits ABOVE MapBazzar product listings. Compact one-line layout
 * to keep precious mobile real-estate above the map.
 */
const ESSENTIALS_GOAL = 499;
const BAR_GREEN = "#1D9E75";

export default function EssentialsCheckBar({ credits = 0, onBook, onSignIn, isAuthed = true }) {
  const pts = Math.max(0, Math.floor(credits));
  const pct = Math.min(100, Math.round((pts / ESSENTIALS_GOAL) * 100));
  const funded = pts >= ESSENTIALS_GOAL;

  return (
    <div
      data-testid="essentials-check-bar"
      style={{
        background: funded
          ? "linear-gradient(135deg, #E6F7EF, #C7EFDC)"
          : "rgba(255,255,255,0.98)",
        border: `1px solid ${funded ? BAR_GREEN : "#CFE8DB"}`,
        borderRadius: 100,
        padding: "7px 10px 7px 12px",
        boxShadow: funded ? "0 6px 16px rgba(29,158,117,0.22)" : "0 4px 12px rgba(15,61,46,0.08)",
        display: "flex", alignItems: "center", gap: 10,
      }}
    >
      <span style={{ fontSize: 16, flexShrink: 0 }}>{funded ? "🌱" : "💚"}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
          <div style={{ ...S.fraunces, fontSize: 11.5, fontWeight: 800, color: "#0F3D2E", lineHeight: 1.3, flex: 1 }}>
            {funded
              ? "Free check unlocked"
              : "See Local Store Inventory Online. Get Home Delivery. Earn Free Sugar-BP-Health Checkups."}
          </div>
          <div data-testid="essentials-check-points" style={{ fontSize: 11, fontWeight: 800, color: funded ? BAR_GREEN : "#0F3D2E", whiteSpace: "nowrap" }}>
            {pts.toLocaleString()}/{ESSENTIALS_GOAL}
          </div>
        </div>
        <div
          role="progressbar"
          aria-valuenow={pts}
          aria-valuemax={ESSENTIALS_GOAL}
          style={{
            marginTop: 4, position: "relative",
            width: "100%", height: 6, borderRadius: 100,
            background: "#E8F0EC", overflow: "hidden",
          }}
        >
          <div
            data-testid="essentials-check-fill"
            style={{
              width: `${pct}%`, height: "100%",
              background: `linear-gradient(90deg, ${BAR_GREEN}, #2BC084)`,
              borderRadius: 100,
              transition: "width 480ms cubic-bezier(0.22, 1, 0.36, 1)",
              boxShadow: pct > 0 ? "0 0 8px rgba(29,158,117,0.4)" : "none",
            }}
          />
        </div>
      </div>
      {!isAuthed ? (
        <button
          data-testid="essentials-check-signin-btn"
          onClick={onSignIn}
          style={{
            padding: "6px 11px", borderRadius: 100, border: "none",
            background: "#0F3D2E", color: "white", fontWeight: 800, fontSize: 10.5,
            cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0,
          }}
        >Sign in</button>
      ) : funded ? (
        <button
          data-testid="essentials-check-book-btn"
          onClick={onBook}
          style={{
            padding: "6px 12px", borderRadius: 100, border: "none",
            background: BAR_GREEN, color: "white", fontWeight: 800, fontSize: 10.5,
            cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0,
            boxShadow: "0 6px 14px rgba(29,158,117,0.4)",
            animation: "essentialsPulse 1.6s ease-in-out infinite",
          }}
        >🎁 Book</button>
      ) : null}
      <style>{`@keyframes essentialsPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.06); } }`}</style>
    </div>
  );
}

export { ESSENTIALS_GOAL };
